<template>
    <div class="container">
      <Head :showBorder="2" />
      <div class="ourselves">
        <img class="ourselves1" src="../assets/ourselves1.jpg" alt="" />
        <img class="ourselves2" src="../assets/ourselves2.jpg" alt="" />
      </div>
      <Bottom/>
    </div>
  </template>
  
  <script>
  import Head from "@/view/module/head.vue";
  import Bottom from "@/view/module/bottom.vue";
  export default {
    name: "index",
    data() {
      return {};
    },
    components: {
      Head,
      Bottom
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .ourselves{
    display: grid;
  }
  .ourselves2{
    width: 100%;
    /* height: 606px; */
  }
    .ourselves1{
        width: 100%;
        /* height: 597px; */
    }
  </style>
  


// WEBPACK FOOTER //
// src/view/ourselves.vue